module.exports = __webpack_public_path__ + "img/bucu_2kl.5c9e2f35.jpg";